
<button mat-icon-button class="nav-button" (click)="onClick()">
  <mat-icon [matBadge]="badge"
            [matBadgeHidden]="!badge"
            matBadgeSize="small"
            [ngClass]="iconClass"
            [fontSet]="fontSet" aria-hidden="false">{{icon}}</mat-icon>
  <span class="button-label" [ngClass]="labelClass">{{label}}</span>
</button>
